<script>
	import { createEventDispatcher } from 'svelte';
	import { fade } from 'svelte/transition';

	const dispatch = createEventDispatcher();
</script>

<div class="darken-overlay" transition:fade={{duration:100}} on:click={ () => dispatch( 'click' ) }/>

<style>
	.darken-overlay {
		position: fixed;
		left: 0px;
		top: 0px;
		width: 100%;
		height: 100%;

		background-color: #000;
		opacity: 0.5;
	}
</style>
